import React, { useState } from 'react';
import axios from 'axios';
import '../styles/CadastrarFuncionario.css';
//esse é o certo
const CadastrarFuncionario = () => {
  const [formData, setFormData] = useState({ username: '', password: '', email: '' });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    
    if (formData.password.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    try {
     await axios.post('https://crmesquita.com.br/api/register/', {
        ...formData,
        is_staff: true, 
      });
      setSuccess('Funcionário cadastrado com sucesso!');
      setError('');
      setFormData({ username: '', password: '', email: '' });
    } catch (error) {
      setError(error.response ? error.response.data.detail : 'Erro ao cadastrar funcionário. Tente novamente.');
      setSuccess('');
    }
  };

  return (
    <div className="cadastrar-funcionario">
      <h1>Cadastrar Funcionário</h1>
      <form onSubmit={handleSubmit} className="funcionario-form">
        <div>
          <label htmlFor="username">Usuário:</label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="email">E-mail:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Senha:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
        </div>
        <button type="submit">Cadastrar</button>
      </form>
      {success && <p className="success-message">{success}</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default CadastrarFuncionario;
